<ng-container *ngIf="model">
  <div infiniteScroll
       [infiniteScrollDistance]="3"
       [infiniteScrollThrottle]="50"
       [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
       (scrolled)="scrollPage(model?.pagination?.currentPage + 1)">
    <div *ngIf="model?.products?.length" class="d-flex justify-content-end">
      <button class="cursor-pointer mb-search-collapse-expand-all-button"
              [disabled]="areResultsCollapsed"
              [innerHTML]="'searchFilterPane.collapseAll' | mbTranslate"
              (click)="handleExpandCollapseClick()">
      </button>
      <div>|</div>
      <button class="cursor-pointer mb-search-collapse-expand-all-button"
              [disabled]="!areResultsCollapsed"
              [innerHTML]="'searchFilterPane.expandAll' | mbTranslate"
              (click)="handleExpandCollapseClick()">
      </button>
    </div>
    <mb-search-result-item-wrapper class="cx-product-search-list"
                                   [model]="product"
                                   [areResultsCollapsed]="areResultsCollapsed"
                                   *ngFor="let product of model.products">
    </mb-search-result-item-wrapper>
    <div
      [className]="[!isLastPage && model?.pagination?.currentPage > 0 ? 'cx-double-btn-container' : 'cx-single-btn-container', 'row no-gutters']">
      <div *ngIf="isMaxProducts && !isLastPage"
           class="col-12 text-center">
        <h3 class="d-block mt-5 mb-4 mb-search-load-more-results-text"
             [innerHTML]="'productList.weFoundMoreProducts' | mbTranslate : {resultsNo: numberOfResultsLeft}">
        </h3>
        <button class="btn btn-secondary mb-search-load-more-results-btn"
                [innerHTML]="'productList.loadMoreBtn' | mbTranslate : {itemsNo: numberOfResultsLeft < searchPageSize ? numberOfResultsLeft : searchPageSize}"
                (click)="loadNextPage(model?.pagination?.currentPage + 1)">
        </button>
      </div>

      <div *ngIf="(isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0"
           class="col-12 text-center mt-3 mb-5 mb-search-back-to-top-btn"
           [innerHTML]="'productList.backToTopBtn' | mbTranslate"
           (click)="scrollToTop()">
      </div>
    </div>
    <cx-spinner class="cx-spinner"
                *ngIf="appendProducts">
    </cx-spinner>
  </div>
</ng-container>
